import React from 'react';
import { CellContext } from '@tanstack/react-table';
import cn from 'classnames';

import { AdaptiveTableCell, DynamicIconWrapper, Icons } from '@components/common';

import { useOnClickOutside } from '@hooks/utils/useOnClickOutSide';

import { EExportFileTypes, TApiDocsGroups } from '@enums/common';

import { columnSizes } from '@constants/table';

import styles from './ApiDocumentation.module.scss';

const FileTypes = {
	XLSX: EExportFileTypes.xlsx,
	CSV: EExportFileTypes.csv,
	JSON: EExportFileTypes.json,
};

export type TFileExtensions = keyof typeof FileTypes;

export function getColumns({
	nodeRef,
	setPlatform,
	platform,
	handleExport,
	handleSetPlatform,
}: {
	nodeRef: React.RefObject<HTMLDivElement>;
	setPlatform: React.Dispatch<React.SetStateAction<TApiDocsGroups | undefined>>;
	platform: TApiDocsGroups | undefined;
	handleExport: (platform: TApiDocsGroups, fileType: TFileExtensions) => void;
	handleSetPlatform: (value: TApiDocsGroups) => () => void;
}) {
	return [
		{
			header: 'PLATFORM',
			accessorKey: 'title',
			size: columnSizes.size360,
			cell: ({ getValue }: CellContext<any, any>) => {
				const value = getValue();

				return (
					<AdaptiveTableCell
						className={styles.assetIdColumnContainer}
						text={value}
					/>
				);
			},
		},
		{
			header: 'Actions',
			accessorKey: 'actions',
			enableSorting: false,
			cell: function Cell({ row }: CellContext<any, any>) {
				const classNames = cn(styles.formatItem);

				useOnClickOutside({
					refs: [nodeRef],
					handler: () => setPlatform(undefined),
				});

				const onItemClick = (fileType: TFileExtensions) => () => {
					handleExport(row.original.platform, fileType);
				};

				return (
					<div className={styles.exportIcon}>
						<DynamicIconWrapper
							icon={Icons.export}
							onClick={handleSetPlatform(row.original.platform)}
							tooltipLabel='Export'
							tooltipPlacement='top'
							withHover
						/>
						{platform === row.original.platform
							&& (
								<div
									ref={nodeRef}
									className={styles.formats}
								>
									{
										Object.entries(FileTypes).map(([key, fileType]) => {
											return (
												<div
													key={key}
													className={classNames}
													onClick={onItemClick(fileType as TFileExtensions)}
												>
													Export as {fileType}
												</div>
											);
										})
									}
								</div>
							)
						}
					</div>
				);
			},
		},
	];
}
